import type { SVGProps } from "react";
import { memo } from "react";
const APIGateway = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#B0084D" />
        <stop offset="100%" stopColor="#FF4F8B" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M0 0h80v80H0z" />
      <path
        fill="#FFF"
        d="M34.065 55.632H37v-2.017h-2.935zm4.935 0h3v-2.017h-3zM27 14.63l-13 6.453v40.111l13 4.397zm2 12.764v26.222h3v2.017h-3v11.36c0 .324-.155.629-.416.818a1 1 0 0 1-.902.138l-15-5.072A1.01 1.01 0 0 1 12 61.92V20.454c0-.384.217-.735.559-.905l15-7.445a.99.99 0 0 1 .969.049c.293.183.472.507.472.856v12.367h3v2.017zm15 28.24h3v-2.018h-3zm.065-28.24H47v-2.017h-2.935zm-5 0H42v-2.017h-2.935zm-5 0H37v-2.017h-2.935zM66 21.083l-13-6.454v50.96l13-4.396zm2 40.837c0 .432-.274.817-.682.956l-15 5.072a.99.99 0 0 1-.902-.138 1.01 1.01 0 0 1-.416-.819V55.632h-1.935v-2.017H51V27.393h-1.935v-2.017H51V13.01c0-.35.179-.673.472-.856a.99.99 0 0 1 .969-.049l15 7.445c.342.17.559.521.559.905zM42.934 33.807l-1.868-.724-5 13.11 1.868.725zm6.773 6.402a1.013 1.013 0 0 0 0-1.426l-4-4.034-1.414 1.426 3.293 3.32-3.293 3.322 1.414 1.426zm-15.414 4.034-4-4.034a1.013 1.013 0 0 1 0-1.426l4-4.034 1.414 1.426-3.293 3.32 3.293 3.322z"
      />
    </g>
  </svg>
);
const Memo = memo(APIGateway);
export default Memo;
